"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundLayer = void 0;
const FixRatioContainer_1 = require("../Common/FixRatioContainer");
const inversify_1 = require("inversify");
const GameConfig_1 = require("../Core/GameConfig");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const pixi_js_1 = require("pixi.js");
let BackgroundLayer = class BackgroundLayer extends FixRatioContainer_1.FixRatioContainer {
    constructor(config, resources, events) {
        var _a;
        super(0, 0);
        const bg = new pixi_js_1.Sprite((_a = resources.background) === null || _a === void 0 ? void 0 : _a.texture);
        bg.alpha = 1 - config.backgroundDim;
        this.setInit(bg.width, bg.height);
        {
            const [w, h] = events.Resize.prevArgs;
            this.resize(w, h, true);
        }
        events.Resize.add((remove, w, h) => {
            if (!this.parent)
                return remove();
            this.resize(w, h, true);
        });
        this.addChild(bg);
    }
};
BackgroundLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameConfig_1.GameConfig, SymbolClasses_1.Resources, SymbolClasses_1.GlobalEvents])
], BackgroundLayer);
exports.BackgroundLayer = BackgroundLayer;
//# sourceMappingURL=BackgroundLayer.js.map